package com.milta.feature.admin.presentation

import com.milta.feature.admin.domain.entity.AdminClaudeUsagePeriod

sealed interface AdminClaudeUsageIntent {
    data object Load : AdminClaudeUsageIntent
    data class ChangePeriod(val period: AdminClaudeUsagePeriod) : AdminClaudeUsageIntent
    data class ChangeView(val view: AdminClaudeUsageViewMode) : AdminClaudeUsageIntent
    /** Expands the row if collapsed (fetching its events on first expand only, see
     * [AdminClaudeUsageState.eventsByAccount]), collapses it if already expanded. */
    data class ToggleAccountRow(val accountId: String) : AdminClaudeUsageIntent
}
